// ==========================================
// Demo Request Lead Conversion (Thank You Page)
// ==========================================
if (window.location.pathname.includes("/pages/thankyou")) {
  if (typeof gtag === "function") {
    // GA4 generate_lead event
    gtag("event", "generate_lead", {
      send_to: "G-F7LM2ZY7R9",
      form_name: "SAR Coffee Demo Form",
      value: 1,
      currency: "INR"
    });

    // Google Ads Instant Conversion Tracking (Demo Form)
    gtag('event', 'conversion', {'send_to': 'AW-18215098418/v5B4CMCo09UcELKw0e1D'});

    console.log("GA4 & Google Ads: generate_lead conversion fired on thank-you page");
  }
}




// ==========================================
// Brochure Form Download Success
// ==========================================
document.addEventListener("brochureDownloadSuccess", function () {
  if (typeof gtag === "function") {
    // GA4 brochure_submit event
    gtag("event", "brochure_submit", {
      send_to: "G-F7LM2ZY7R9",
      form_id: "SarBrochureForm",
      form_name: "SAR Coffee Brochure Form"
    });

    // Google Ads Instant Conversion Tracking (Brochure Download - separate action)
    gtag('event', 'conversion', {'send_to': 'AW-18215098418/NUC7CPvbnNccELKw0e1D'});

    console.log("GA4 & Google Ads: brochure_submit conversion fired on download success");
  }
});

// ==========================================
// Phone Click Tracking
// ==========================================
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".coffee-phone").forEach(function (button) {
    button.addEventListener("click", function (e) {
      if (typeof gtag === "function") {
        e.preventDefault();
        var url = this.href;
        var callbackFired = false;
        
        function actionFn() {
          if (!callbackFired) {
            callbackFired = true;
            window.location.href = url;
          }
        }

        gtag("event", "phone_click", {
          send_to: "G-F7LM2ZY7R9",
          phone_number: url.replace("tel:", "")
        });
        
        gtag('event', 'conversion', {
          'send_to': 'AW-18215098418/Y6bFCLCP9NgcELKw0e1D',
          'event_callback': actionFn
        });
        
        // Fallback safety timeout if gtag is blocked
        setTimeout(actionFn, 500);
        
        console.log("GA4 & Google Ads: phone_click fired reliably");
      }
    });
  });
});
